import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ActivationCodeRenewComponent } from './rinnova-codice-attivazione';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.rinnova-codice-attivazione', {
            url: '/rinnova-codice-attivazione',
            views: {
                'userContent': {
                    template: '<rinnova-codice-attivazione></rinnova-codice-attivazione>'
                }
            },
            ncyBreadcrumb: {
                label: 'Codice Attivazione',
                parent: 'usersettings.rinnova-offerta'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Codice Attivazione'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const RinnovaCodiceAttivazioneModule: string = ng
    .module('archiSmall.userSettings.rinnovaCodiceAttivazioneModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('rinnovaCodiceAttivazione', ActivationCodeRenewComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/rinnova-codice-attivazione/rinnova-codice-attivazione.module.ts